import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UserContext from "../context/UserContext";
import "../styles/Nav.css";

const Nav = ({ menuOpen, toggleMenu }) => {
  const { authUser } = useContext(UserContext);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/");
  };

  return (
    <nav>
      <div className="nav-header">
        <button className="hamburger" onClick={toggleMenu}>☰</button>
      </div>

      <div className={`nav-buttons ${menuOpen ? "open" : ""}`}>
        {authUser === null ? (
          <>
            <Link className="nav-link" to="/signin">Sign in</Link>
            <Link className="nav-link" to="/signup">Sign up</Link>
            <Link className="nav-link" to="/contact">Contact</Link>
            <Link className="nav-link" to="/editmedia">Services</Link>
            <Link className="nav-link" to="/beatbattle">Battle</Link>
          </>
        ) : (
          <>
            {authUser && <span className="welcome-text">Welcome {authUser.name}</span>}
            <Link className="nav-link" to="/authenticated">Home</Link>
            {authUser.email === "support@editfarmer.com" && (
              <>
                <Link className="nav-link" to="/popcustom">PopCustom</Link>
                <Link className="nav-link" to="/farmertv">FarmerTv</Link>
                <Link className="nav-link" to="/theadministrator">Admin</Link>
              </>
            )}
            <Link className="nav-link" to="/digistore">Store</Link>
            <Link className="nav-link" to={`/digiprev/${authUser._id}`}>Digi</Link>
            <Link className="nav-link" to="/digimanager">Manager</Link>
            <Link className="nav-link" to={`/checkOut/${authUser._id}`}>Checkout</Link>
            <Link className="nav-link" to="/settings">Settings</Link>
            <Link className="nav-link" to="/beatbattle">Battle</Link>
            <Link className="nav-link" to="/signout">Log Out</Link>
          </>
        )}
      </div>

      <img
        src={hovered ? "/otherclick2.0.png" : "/clicklogo 2.0.png"}
        alt="Banner"
        className="editIcon"
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{ cursor: "pointer" }}
      />
    </nav>
  );
};

export default Nav;
